import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components/macro";
import { sendAppEvent } from "../../Utils";
import { NewHomepageContainer } from "./styles"; //TODO: break this apart
import SudowriteLogo from "../SudowriteLogo";

const StyledFooterModule = styled.section`
  .content-row {
    align-items: flex-start;
    .footer-header {
      font-family: "Inter";
      line-height: 130%;
      font-weight: 600;
      width: 115px;
      text-align: left;
    }
    .footer-item {
      cursor: pointer;
      font-family: "Inter";
      line-height: 130%;
      font-weight: 500;
      opacity: 0.5;
    }
  }

  @media (max-width: 700px) {
    //mobile-lg
    #legal,
    #product {
      display: none;
    }

    .hide-on-mobile-lg {
      display: none;
    }
  }
`;

const Footer = ({ theme, openLogin, user }) => {
  const history = useHistory();

  return (
    <NewHomepageContainer>
      <StyledFooterModule
        className={theme}
        id="footer-module"
      >
        <div className="spacer-lg"></div>
        <div
          className="content-row"
          id="sitemap"
        >
          <SudowriteLogo
            isLink
            stacked
            size="medium"
          />
          <div className="spacer-small"></div>
          <div className="spacer-small hide-on-mobile-lg"></div>
          <div className="spacer-small hide-on-mobile-lg"></div>
          <div
            className="content-column"
            id="product"
          >
            <p className="footer-header">Learn</p>
            <p className="footer-item">
              <a
                href="https://feedback.sudowrite.com/changelog/"
                target="_blank"
              >
                Changelog
              </a>
            </p>
            <p className="footer-item">
              <a
                href="https://lu.ma/sudowrite/"
                target="_blank"
                rel="noreferrer"
              >
                Live Classes
              </a>
            </p>
            <>
              {user ? (
                <p className="footer-item">
                  <a
                    target="_blank"
                    href="https://feedback.sudowrite.com/feedback?type=t62e6f3df7ded2&sort=trend&filter=all-nc"
                  >
                    Vote on Features
                  </a>
                </p>
              ) : (
                <>
                  <p className="footer-item">
                    <a href={`${process.env.REACT_APP_MARKETING_PAGE_URL}/#testimonials-module`}>Testimonials</a>
                  </p>
                  <p
                    className="footer-item"
                    onClick={(e) => {
                      e.preventDefault();
                      history.push("/");
                      window.scrollTo(0, 0);
                      sendAppEvent("Click Join the Beta", { position: "top" });
                      openLogin();
                    }}
                  >
                    Try Sudowrite
                  </p>
                  <p
                    className="footer-item"
                    onClick={(e) => {
                      e.preventDefault();
                      window.location.href = `${process.env.REACT_APP_MARKETING_PAGE_URL}/faq`;
                      window.scrollTo(0, 0);
                    }}
                  >
                    FAQ
                  </p>
                </>
              )}
            </>
          </div>
          <div
            className="spacer-small"
            id="social"
          ></div>
          <div className="content-column">
            <p className="footer-header">Connect</p>
            <p className="footer-item">
              <a
                href="https://discord.gg/wgZAK9RRfv"
                target="_blank"
                rel="noreferrer"
              >
                Join Our Discord
              </a>
            </p>
            <p className="footer-item">
              <a href="https://sudowrite.notion.site/Sudowrite-Affiliate-Program-12788b26b71746f2a72cd05b7087e8c9">Become an Affiliate</a>
            </p>
            <p className="footer-item">
              <a
                href="https://twitter.com/sudowrite"
                target="_blank"
              >
                X (aka Twitter)
              </a>
            </p>
            <p className="footer-item">
              <a href="mailto:hi@sudowrite.com">Email Us</a>
            </p>
          </div>
          <div className="spacer-small hide-on-mobile-lg"></div>
          <div
            className="content d-column"
            id="legal"
          >
            <p className="footer-header">Legal</p>
            <p className="footer-item">
              <a
                href="https://sudowrite.notion.site/Terms-and-Conditions-83ddd78e1ab04d9d88321a9ef7665925"
                target="_blank"
              >
                Terms & Conditions
              </a>
            </p>
            <p className="footer-item">
              <a
                href="https://sudowrite.notion.site/Privacy-Policy-710e53e814f8491b8ee2634ee9162ed8"
                target="_blank"
              >
                Privacy Policy
              </a>
            </p>
          </div>
        </div>
        <div className="spacer-small"></div>
        <div className="spacer-small hide-on-desktop"></div>
        <div className="content-row">
          <p className="footer-item">
            🚀 We're hiring an&nbsp;
            <a href="https://sudowrite.notion.site/We-re-hiring-engineers-and-a-community-manager-to-make-writing-magical-389c57f5ae3a421d8f8c0b48c8407e88">
              <u>AI Engineer</u>
            </a>
            !
          </p>
        </div>
        <div className="spacer-lg smaller-on-mobile"></div>
      </StyledFooterModule>
    </NewHomepageContainer>
  );
};

export default Footer;
